/**
 * @fileoverview The application's single configured Axios instance.
 * @description Creates the one Axios client every REST call goes through, wired with the shared
 * request/response interceptors. modules/*\/services files call this instead of importing axios
 * directly, so base URL, auth headers, and error normalization are applied everywhere consistently.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import axios from 'axios'

import { apiConfig } from '@/config/api-config'
import { attachAuthToken, attachCorrelationId } from '@/shared/api/interceptors/request.interceptor'
import {
  handleResponseError,
  handleResponseSuccess,
  setHttpClient,
} from '@/shared/api/interceptors/response.interceptor'

export const httpClient = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: apiConfig.timeoutMs,
  // The identity backend issues the refresh token as an httpOnly cookie rather than in the
  // response body, so it needs to be sent automatically on cross-request calls to this API origin.
  withCredentials: true,
})

setHttpClient(httpClient)

httpClient.interceptors.request.use(attachAuthToken)
httpClient.interceptors.request.use(attachCorrelationId)
httpClient.interceptors.response.use(handleResponseSuccess, handleResponseError)
